import { MdOutlineEditCalendar, MdOutlineSupportAgent } from 'react-icons/md';

export interface CtaButtonProps {
  text: string;
  onClick: () => void;
  color: string;
  secondaryColor: string;
  isMobile?: boolean;
  icon?: 'calendar' | 'support' | 'none';
}

export const CtaButton = ({
  text,
  onClick,
  color,
  secondaryColor,
  isMobile,
  icon = 'calendar',
}: CtaButtonProps) => {
  const iconSize = isMobile ? 16 : 18;
  const renderIcon = () => {
    if (icon === 'none') return null;
    if (icon === 'support') {
      return <MdOutlineSupportAgent size={iconSize} color={color} />;
    }
    return <MdOutlineEditCalendar size={iconSize} color={color} />;
  };

  const baseClassName =
    'flex w-full cursor-pointer items-center justify-center gap-2 rounded-2xl font-semibold shadow-sm transition-all duration-200 hover:brightness-[0.98] hover:shadow-md active:scale-[0.99] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-[#f5f7f8]';

  if (isMobile) {
    return (
      <button
        className={`${baseClassName} min-w-0 px-3 py-2.5 text-xs`}
        style={{ color, backgroundColor: secondaryColor }}
        onClick={onClick}
        type='button'
      >
        {text}
        {renderIcon()}
      </button>
    );
  }

  return (
    <button
      className={`${baseClassName} min-w-[307px] px-3 py-3 text-[15px]`}
      style={{ color, backgroundColor: secondaryColor }}
      onClick={onClick}
      type='button'
    >
      {text}
      {renderIcon()}
    </button>
  );
};
